export const defaultLocale = "en"
export const locales = ["en", "am"] as const
export type Locale = (typeof locales)[number]

export const localeNames: Record<Locale, string> = {
  en: "English",
  am: "አማርኛ"
  
}


// export const defaultLocale = "en"
// export const locales = ["en", "am", "oro", "tig"] as const
// export type Locale = (typeof locales)[number]

// export const localeNames: Record<Locale, string> = {
//   en: "English",
//   am: "አማርኛ",
//   oro: "Afaan Oromoo",
//   tig: "ትግርኛ",
  
// }